function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.6,
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#E7F2F5"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0812 13.008L13.8412 14.848L12.7212 13.52L16.2572 10.672H18.0012V22H16.0812V13.008Z",
  fill: "#117A9B"
});

const SvgOne = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOne, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/one.a054446c.svg";
export { ForwardRef as ReactComponent };